import * as classnames from "classnames";
import * as React from "react";

import { Button, ButtonType, Msg } from "..";
import { ApplicantExamModel } from "../../models";
import { ChallengeStyle } from "../../services/enums";

/**
 * Prop interface
 */
export interface ApplicantChallengeLinkProps {
  exam: ApplicantExamModel;
  challengeId: number;
  className?: string;
  tutorial?: boolean;
}

interface ApplicantChallengeLinkAttribute {
  type?: ButtonType;
  path: string;
  message: React.ReactNode;
  ariaLabel: string;
}

/**
 * React Component
 */
export default function ApplicantChallengeLink({
  exam,
  challengeId,
  className,
  tutorial,
}: ApplicantChallengeLinkProps) {
  const rootStyle = classnames("code-c-applicant-challenge-link", {
    [`${className}`]: Boolean(className),
  });

  const style = exam.getChallengeByChallengeId(challengeId).style;

  let attributes: ApplicantChallengeLinkAttribute | undefined;

  let urlPath = `/challenges/${challengeId}`;

  if (style === ChallengeStyle.Quiz) {
    urlPath = `${urlPath}/1`;
  }

  if (style === ChallengeStyle.Frontend) {
    urlPath = `${urlPath}?h=1`;
  }

  if (exam.isChallengeStarted(challengeId)) {
    attributes = {
      path: urlPath,
      message: (
        <Msg
          id="applicant-challenge-link.updateAnswer"
          defaultMessage="解答を修正する"
        />
      ),
      ariaLabel: "Update Answer",
    };
  } else if (exam.isChallengeFinished(challengeId)) {
    if (
      ChallengeStyle.hasAppealComment(style) &&
      exam.isChallengeFinished(challengeId) &&
      exam.isInProgress()
    ) {
      attributes = {
        path: `/appeal/${challengeId}`,
        message: (
          <Msg
            id="applicant-challenge-link.addAppeal"
            defaultMessage="アピールコメントを記入する"
          />
        ),
        ariaLabel: "Add Appeal Comment",
      };
    }
  } else {
    attributes = {
      type: "primary",
      path: urlPath,
      message: (
        <Msg
          id="applicant-challenge-link.startAnswer"
          defaultMessage="解答する"
        />
      ),
      ariaLabel: "Start Challenge",
    };
  }

  return attributes ? (
    <Button
      className={rootStyle}
      route={{
        pathname: `/${tutorial ? "tutorial" : exam.org.name}/exams/${
          exam.urlToken
        }${attributes.path}`,
      }}
      pageReload={style === ChallengeStyle.Frontend}
      type={attributes.type}
      ariaLabel={attributes.ariaLabel}
    >
      {attributes.message}
    </Button>
  ) : null;
}
